import { createContext, type ReactNode, useContext, useState } from "react";

interface CartPageProviderProps {
  children: ReactNode;
  initialDisableCheckout: boolean;
  initialShowSubtotal: boolean;
}

interface CartPageContextType {
  disableCheckout: boolean;
  showSubtotal: boolean;
  setDisableCheckout: (value: boolean) => void;
}
const CartPageContext = createContext<CartPageContextType | undefined>(undefined);

export const CartPageContextProvider = ({
  children,
  initialDisableCheckout,
  initialShowSubtotal,
}: CartPageProviderProps) => {
  const [disableCheckout, setDisableCheckout] = useState(initialDisableCheckout);

  return (
    <CartPageContext.Provider
      value={{
        disableCheckout: initialDisableCheckout || disableCheckout,
        setDisableCheckout,
        showSubtotal: initialShowSubtotal,
      }}
    >
      {children}
    </CartPageContext.Provider>
  );
};

export const useCartPageContext = (): CartPageContextType => {
  const context = useContext(CartPageContext);
  if (!context) {
    throw new Error("useCartPageContext must be used within a CartPageContextProvider");
  }
  return context;
};
